import { render, staticRenderFns } from "./QuestionPreliminairePermisPsychologue.vue?vue&type=template&id=a36099bc"
import script from "./QuestionPreliminairePermisPsychologue.vue?vue&type=script&lang=js"
export * from "./QuestionPreliminairePermisPsychologue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports